import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Container } from '~/pages/Main/index.styled';
import { FlexStack } from '~/components/atomic';
import {
  TypeButtonSkeleton,
  CharacterCard,
  ExploreBanner,
  GroupChatCard,
  TextSkeleton,
} from '~/components/atomic/Skeleton';
import { makeIndexArray } from '~/utils';

export default function MainSkeleton() {
  return (
    <Container>
      <FlexStack spacing={32}>
        <ExploreBanner />

        <FlexStack
          spacing={32}
          css={css`
            padding-left: 16px;
          `}
        >
          <FlexStack spacing={16}>
            <TextSkeleton
              css={css`
                width: 60%;
              `}
            />
            <CardWrapper>
              {makeIndexArray(6).map((el) => (
                <CharacterCard key={el} width={214} height={257} />
              ))}
            </CardWrapper>
          </FlexStack>
          <FlexStack spacing={16}>
            <FlexStack
              direction='row'
              css={css`
                justify-content: space-between;
              `}
            >
              <TextSkeleton
                css={css`
                  width: 10%;
                `}
              />
              <TextSkeleton
                css={css`
                  width: 10%;
                `}
              />
            </FlexStack>
            <CardWrapper>
              {makeIndexArray(8).map((el) => (
                <CharacterCard key={el} width={110} />
              ))}
            </CardWrapper>
          </FlexStack>
        </FlexStack>

        <FlexStack
          css={css`
            padding: 0 16px;
          `}
          spacing={16}
        >
          <TextSkeleton
            css={css`
              width: 20%;
            `}
          />
          <FlexStack direction='row'>
            {makeIndexArray(3).map((el) => (
              <TypeButtonSkeleton key={el} />
            ))}
          </FlexStack>
          <FlexStack>
            {makeIndexArray(3).map((el) => (
              <GroupChatCard key={el} />
            ))}
          </FlexStack>
        </FlexStack>
      </FlexStack>
    </Container>
  );
}

const CardWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: hidden;
  gap: 8px;
`;
